import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar, Calculator } from "lucide-react";
import Reveal from "./Reveal";

export default function CtaBanner() {
  return (
    <section className="relative py-20 lg:py-28 bg-[#0A192F] text-white overflow-hidden" data-testid="cta-banner">
      {/* Blueprint bg */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1721244654394-36a7bc2da288?auto=format&fit=crop&w=2000&q=85"
          alt=""
          aria-hidden
          className="w-full h-full object-cover opacity-20"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F] via-[#0A192F]/92 to-[#123E73]/80" />
        <div className="absolute inset-0 blueprint-grid-dark opacity-70 pointer-events-none" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <Reveal>
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#F5A400]" />
            <span className="text-xs tracking-[0.3em] font-semibold text-[#F5A400]">READY WHEN YOU ARE</span>
          </div>
          <h2 className="font-display font-bold text-4xl sm:text-6xl lg:text-[72px] leading-[0.98] tracking-tight text-white max-w-5xl">
            LET&apos;S GET YOUR <span className="text-[#F5A400]">PROJECT STARTED.</span>
          </h2>
          <p className="mt-6 text-base lg:text-xl text-white/75 max-w-2xl leading-relaxed">
            From concept to completion, we build with precision and excellence. Book a free
            consultation or request a no-obligation estimate today.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4" data-testid="cta-banner-buttons">
            <a
              href="#contact-form"
              className="group inline-flex items-center justify-center gap-2 bg-[#F5A400] text-[#0A192F] hover:bg-[#D99000] font-bold px-8 py-4 transition-all duration-300 hover:-translate-y-0.5"
              data-testid="cta-book-consultation"
            >
              <Calendar className="w-4 h-4" />
              Book Consultation
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </a>
            <a
              href="#contact-form"
              className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-md border border-white/30 text-white hover:bg-white hover:text-[#0A192F] font-bold px-8 py-4 transition-all duration-300"
              data-testid="cta-get-estimate"
            >
              <Calculator className="w-4 h-4" />
              Get Free Estimate
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
